import { cn } from '@/shared/lib/utils';

type Props = {
  className?: string;
};

export const ProductLogo = ({ className }: Props) => {
  return <img src="/product-logo.svg" alt="WiseVine BnS" className={cn('h-5', className)} />;
};
